export const defaultSorting = 'relevancy';

export const sortingValues = ['relevancy', 'stars'];
